import { Platform, Linking } from 'react-native';

export const openUrl = (url) => {
  if (Platform.OS === 'web') {
    window.open(url);
  } else {
    Linking.openURL(url)
  }
};
